<template>
  <v-app>
    <v-container class="pa-0 ma-0 d-flex flex-column align-center">
      <!-- header -->
      <v-container class="pa-3 ma-0 product-header">
        <v-card-text class="pa-0 ma-0 header-title">
          {{ $t("product_details") }}
        </v-card-text>
        <v-icon class="back-icon" @click="$emit('close')"> mdi-chevron-left </v-icon>
      </v-container>

      <!-- details section -->
      <v-container class="pa-6 ma-0 d-flex flex-column gap-3 product-details-card">
        <!-- product img -->
        <v-img :src="product.image" alt="" height="auto" class="product-image" cover />

        <!-- product details -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3 food-info">
          <v-container class="pa-0 ma-0 lastSection">
            <v-sheet class="pa-0 ma-0 d-flex flex-column gap-1">
              <v-card-text class="pa-0 ma-0 food-price px-2">
                {{ product.price }} {{ $store.state.currency.name }}
              </v-card-text>
            </v-sheet>

            <!-- cart actions -->
            <v-sheet class="pa-0 ma-0 action-buttons">
              <v-btn
                outlined
                color="#007AFF"
                class="add-btn"
                v-if="getCount(product.id) === 0"
                @click="$emit('add', product)"
                height="20"
                width="20"
              >
                {{ $t("add") }}
                <v-icon size="16" class="mr-2">mdi-plus</v-icon>
              </v-btn>

              <v-container v-else class="pa-0 ma-0 counter">
                <v-btn
                  outlined
                  color="#007AFF"
                  @click="$emit('add', product)"
                  height="18"
                  width="18"
                  style="min-width: auto"
                >
                  <v-icon size="15">mdi-plus</v-icon>
                </v-btn>
                <div class="count">{{ getCount(product.id) }}</div>
                <v-btn
                  outlined
                  color="#007AFF"
                  @click="$emit('remove', product)"
                  :disabled="getCount(product.id) === 0"
                  height="18"
                  width="18"
                  style="min-width: auto"
                >
                  <v-icon size="15">mdi-minus</v-icon>
                </v-btn>
              </v-container>
            </v-sheet>
          </v-container>
          <v-card-text class="pa-0 ma-0 food-title px-2">{{ product.name }}</v-card-text>
          <v-card-text class="pa-0 ma-0 food-desc px-2">{{ product.desc }}</v-card-text>
        </v-container>
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "ProductDetails",
  props: {
    product: {
      type: Object,
      default: () => null,
    },
    cartItems: { type: Array, required: true },
  },
  computed: {},
  methods: {
    getCount(id) {
      const item = this.cartItems.find((i) => i.id === id);
      return item?.count || 0;
    },
  },
};
</script>

<style scoped>
.lastSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  direction: rtl;
  width: 100%;
}
.product-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  direction: rtl;
  height: 60px;
  border-bottom: solid 1px #d9d9d9;
  background-color: transparent;
}
.header-title {
  font-weight: 700;
  font-size: 18px;
  color: #1a1a1a;
}
.back-icon {
  font-size: 36px;
  cursor: pointer;
  color: #1a1a1a;
}
.product-details-card {
  overflow: hidden;
  direction: rtl;
}
.product-image {
  border-radius: 12px;
  object-fit: cover;
  max-height: 303px;
  border: 1px solid #d9d9d9;
}
.food-info {
  text-align: right;
}
.food-title {
  font-weight: 600;
}
.food-desc {
  font-size: 14px;
  color: #666;
  margin: 4px 0;
}
.food-price {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}
.counter {
  display: flex;
  align-items: center;
  gap: 8px;
}
.count {
  font-size: 12px;
  font-weight: 500;
  color: #333;
  background-color: #d9d9d9;
  padding: 4px 14px;
  border-radius: 6px;
}
</style>
